module.exports = __webpack_public_path__ + "img/doorLogo38.8bc78365.png";